import BackgroundLayer from '../animations/layers/BackgroundLayer';
import AmbientLayer from '../animations/layers/AmbientLayer';
import useAnimationPerformance from '../animations/hooks/useAnimationPerformance';

// Import layer styles
import '../animations/styles/layers.css';
import '../animations/styles/ambient.css';

/**
 * PageBackgroundAnimation - Orchestrates layered animation system
 *
 * Architecture:
 * - Layer -1: Static background (always visible, no animation)
 * - Layer 0: Ambient animations (always-on, disabled on mobile)
 *
 * This ensures consistent rendering and performance across devices.
 */
function PageBackgroundAnimation() {
  const {
    enableAmbientAnimations,
    enableWaveEffects,
    enableSpectrogramVisualizers,
    enableCodeTerminals,
    isMobile,
    isLowEndDevice,
  } = useAnimationPerformance();

  return (
    <div className="page-bg-animation-container" data-testid="page-bg-animation">
      <BackgroundLayer />
      <AmbientLayer
        enableAmbientAnimations={enableAmbientAnimations}
        enableWaveEffects={enableWaveEffects}
        enableSpectrogramVisualizers={enableSpectrogramVisualizers}
        enableCodeTerminals={enableCodeTerminals}
      />

      {/* Debug info (optional, remove in production) */}
      {process.env.NODE_ENV === 'development' && (
        <div
          style={{
            position: 'fixed',
            bottom: 10,
            right: 10,
            fontSize: '10px',
            opacity: 0.3,
            zIndex: 9999,
          }}
        >
          <div>Mobile: {isMobile ? 'Yes' : 'No'}</div>
          <div>Low-end: {isLowEndDevice ? 'Yes' : 'No'}</div>
          <div>Ambient: {enableAmbientAnimations ? 'On' : 'Off'}</div>
        </div>
      )}
    </div>
  );
}

export default PageBackgroundAnimation;
